import { createHttpService } from "../ApiService";
import {
  TLocalization,
  TUpdateLocalizationRequest,
} from "./localization.interfaces";
import {
  localizationListMock,
  localizationMock,
} from "../../__mocks__/localization/localizationMock";

export const useLocalizationService = () => {
  const httpAPI = createHttpService();
  const baseLocalizationPath = "";

  // Use mocks when VITE_APP_WITH_MOCK_DATA is set to "true"
  // TODO: remove this once the API is implemented
  const appWithMockData = true; // import.meta.env.VITE_APP_WITH_MOCK_DATA === "true";

  const getLocalization = (instituteId?: string) => {
    if (appWithMockData) {
      // Filter by instituteId if provided
      if (instituteId) {
        const localization = localizationListMock.find(
          (loc) => loc.instituteId === instituteId,
        );
        return Promise.resolve(localization || localizationMock);
      }
      return Promise.resolve(localizationMock);
    }
    const path = instituteId
      ? `${baseLocalizationPath}?instituteId=${instituteId}`
      : `${baseLocalizationPath}`;
    return httpAPI.localization.get<TLocalization>(path);
  };

  const updateLocalization = (
    id: string,
    request: TUpdateLocalizationRequest,
  ) => {
    if (appWithMockData) {
      // In mock, id might be the localization id or instituteId
      // Try to find by id first, then by instituteId
      let index = localizationListMock.findIndex((loc) => loc.id === id);
      if (index === -1) {
        // If not found by id, try to find by instituteId
        index = localizationListMock.findIndex((loc) => loc.instituteId === id);
      }

      if (index === -1) {
        // If still not found, create new entry using id as instituteId
        const newLocalization: TLocalization = {
          id: String(Date.now()),
          instituteId: id,
          currency: request.currency || "",
          language: request.language,
          additionalLanguages: request.additionalLanguages,
          dateFormat: request.dateFormat,
          timeFormat: request.timeFormat,
          numberFormat: request.numberFormat,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        };
        localizationListMock.push(newLocalization);
        return Promise.resolve(newLocalization);
      }
      const updatedLocalization: TLocalization = {
        ...localizationListMock[index],
        ...request,
        updatedAt: new Date().toISOString(),
      };
      localizationListMock[index] = updatedLocalization;
      return Promise.resolve(updatedLocalization);
    }
    return httpAPI.localization.patch<TLocalization>(
      `${baseLocalizationPath}/${id}`,
      request,
    );
  };

  return {
    getLocalization,
    updateLocalization,
  };
};
